import React from 'react';
import { useTranslation } from 'react-i18next';
import './FAQWithJustice.css';

/**
 * FAQWithJustice - Combined section with FAQ on left, Lady Justice image on right
 */

export function FAQWithJustice() {
  const { t } = useTranslation();
  const [expandedId, setExpandedId] = React.useState(null);

  const faqItems = [
    {
      id: 1,
      question: t('faq.items.rights.question'),
      answer: t('faq.items.rights.answer'),
      link: 'https://www.liftourvoices.org/legislativewins',
      linkText: t('faq.items.rights.linkText'),
    },
    {
      id: 2,
      question: t('faq.items.ndaLaws.question'),
      answer: t('faq.items.ndaLaws.answer'),
      link: 'https://www.liftourvoices.org/state-nda-laws',
      linkText: t('faq.items.ndaLaws.linkText'),
    },
    {
      id: 3,
      question: t('faq.items.resources.question'),
      answer: t('faq.items.resources.answer'),
      link: 'https://www.liftourvoices.org/lovresources',
      linkText: t('faq.items.resources.linkText'),
    },
    {
      id: 4,
      question: t('faq.items.trust.question'),
      answer: t('faq.items.trust.answer'),
      isExpandable: true,
    },
  ];

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <section className="faq-justice-section">
      {/* FAQ on the left */}
      <div className="faq-side">
        <h2 className="faq-justice-title">{t('faq.title')}</h2>
        <div className="faq-list-compact">
          {faqItems.map((item) => (
            <div key={item.id} className={`faq-item-compact ${expandedId === item.id ? 'expanded' : ''}`}>
              <button
                className="faq-question-compact"
                onClick={() => toggleExpand(item.id)}
                aria-expanded={expandedId === item.id}
              >
                <span>{item.question}</span>
                <span className="faq-chevron-compact">›</span>
              </button>
              <div className={`faq-answer-compact ${expandedId === item.id ? 'expanded' : ''}`}>
                <p>{item.answer}</p>
                {item.link && (
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="faq-link-compact"
                  >
                    {item.linkText} →
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Workers image on the right */}
      <div className="justice-side">
        <img
          src="/story_images/page 2.jpg"
          alt={t('faqWithJustice.imageAlt')}
          className="justice-side-image"
          draggable="false"
        />
        <div className="justice-side-overlay"></div>
        <div className="justice-side-text">
          <p className="justice-side-subheading">
            {t('faqWithJustice.tagline')}
          </p>
        </div>
      </div>
    </section>
  );
}
